import * as request from "@/utils/request";
import { DefaultConfigs, inApp } from "@/common/js/constant";
import { PayeeParam, detailsInfo } from "./types";
import BusinessVerify, { EnumBusinessFlow, SDK_VERSION } from "@/components/BusinessVerify";
import { setCommonAttrs, trackEvent } from "@/utils/omega";
import APP from "@/utils/app";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

type detailsParams = {
  transactionId: string;
};

// 查询账单流水详情
// 账单详情页面新增保存收款人按钮
// /v0/bill/detail接口新增下游：/user/payee/getDetail，判断一个账户是否已经被保存为收款人
// /v0/bill/detail接口返回值新增字段：needSavePayee，表示是否要展示保存收款人按钮
// /v0/bill/detail接口返回值新增字段：transactionId，作为后面请求保存收款人接口的入参
// 接口文档：http://xmock.intra.xiaojukeji.com/project/420/interface/api/17764
// 请求保存收款人接口需要的参数从当前页面取（只需要transactionId即可）
export function getDetailInfo(params: detailsParams) {
  return request.get<detailsInfo>(
    `${baseUrl}/sofipo/v0/trade/detail?transactionId=${params.transactionId}`,
    {},
  );
}

// 保存收款人
// 新增保存收款人接口
// 接口文档：http://xmock.intra.xiaojukeji.com/project/420/interface/api/27595
// 该接口有两套参数，分别给 收款人信息页面 和 账单详情页面 使用
// 该接口需要做业务核验
export async function savePayee(params: PayeeParam): Promise<void> {
  // 核验版本
  params.verifyInfo = params.verifyInfo || {
    verifySdkVersion: SDK_VERSION,
  };

  try {
    // 提交
    return await request.post<void>(`${baseUrl}/sofipo/v0/trade/payee/create`, params);
  } catch (ret: any) {
    // 业务核验
    if (ret.errno === request.ERROR_TYPE.BusinessVerify) {
      // 设置公参
      setCommonAttrs({
        // scene_source
        // 场景来源
        // 0-风控
        // 1-业务
        scene_source: BusinessVerify.scene,
        // from_source 流程来源
        from_source: EnumBusinessFlow.payeeAfterOrder,
      });

      // 核验拉起时禁止返回按钮
      if (inApp) {
        APP.requestBackPressedControl(() => {});
      }
      // 拉起核验
      return new BusinessVerify()
        .verify(JSON.parse(ret?.data?.bussVerifyResultInfo)?.atoDomain)
        .then((res) => {
          // 重置公参
          setCommonAttrs({
            // scene_source
            // 场景来源
            // 0-风控
            // 1-业务
            scene_source: undefined,
            // from_source 流程来源
            from_source: undefined,
          });
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 核验完成后删掉order id参数
          setCommonAttrs({
            order_id: undefined,
          });

          // 增加核验token
          if (params.verifyInfo) {
            params.verifyInfo.sessionId = res.verify_session_id;
          }
          // 重启发起请求
          return savePayee(params);
        })
        .catch((err) => {
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 技术打点
          trackEvent("tech_sofi_catch_error", {
            source: "billDetail.savePayee.BusinessVerify",
            data: JSON.stringify(err),
          });
          // 透出给交互层
          return Promise.reject(err);
        });
    }
    return Promise.reject(ret);
  }
}
